import { atom } from 'jotai';

/**
 * Represents a selected IFC fragment element's property tree node.
 */
export interface FragmentPropertyNode {
  name: string;
  value?: string | number | boolean;
  localId: number;
  type?: 'relation' | 'related' | 'attribute';
  children?: FragmentPropertyNode[];
}

/**
 * State for a selected IFC fragment element.
 */
export interface SelectedFragmentElement {
  /** The localId of the picked element */
  localId: number;
  /** The modelId (e.g. "frag-<layerId>") */
  modelId: string;
  /** The layer ID this element belongs to */
  layerId: string;
  /** Flat list of top-level properties (attributes + relations) */
  properties: FragmentPropertyNode[];
  /** Whether properties are still loading */
  loading: boolean;
  /** The highlight mesh group added to the scene (for cleanup) */
  highlightMesh?: any;
}

export const selectedFragmentElementAtom = atom<SelectedFragmentElement | null>(null);
